import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "sheeppelt";

function GISheepPelt() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GISheepPelt;